import Text from 'components/Text';
import React from 'react';
import styled from 'styled-components';

type CustomerProfileOverViewProps = {
  icon: React.ReactNode;
  label: string;
  value: string;
};

const CustomerProfileOverView = ({ icon, label, value }: CustomerProfileOverViewProps) => {
  return (
    <Container>
      <IconContainer>{icon}</IconContainer>
      <Label variant='H9'>{label}:</Label>
      <Value variant='H8'>{value}</Value>
    </Container>
  );
};

export default CustomerProfileOverView;

const Container = styled.div`
  display: flex;
  padding: 8px;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  border-radius: 4px;
  background: #c6e9ef;
`;

const IconContainer = styled.div`
  width: 41px;
`;

const Label = styled(Text)`
  min-width: 100px;
  color: #2d6772;
  font-size: 1.5em !important;
  display: flex;
  align-items: center;
`;

const Value = styled(Text)`
  padding-top: 6px;
  font-size: 1.5em !important;
  display: flex;
  align-items: center;
`;
